// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__vSoyM","errors":"Errors_errors__3MZ-4"};